import styled from 'styled-components';

const fontSizes = {
  extra_small: '11px',
  small: '13px',
  medium: '15px',
  large: '18px',
  extra_large: '23px',
  responsive: {
    small: '11px',
    medium: '12px',
    extra_large: '21px',
  }
};

const colors = {
  ivory_pale: '#fcf7f6',
  snowy_white: '#f6f6f6',
  white: '#fff',
  purple: '#9c179e',
  charcoal_gray: '#484848',
  sky_blue: '#41b8d5',
  sunflower_yellow: '#fce83a',
  olive_green: '#c8e066',
  black: '#000',
  light_gray: '#c9c7d0',
};

export const PanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem; /* space-y-6 */
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem; /* gap-3 */
    .title-container {
    display: flex;
    align-items: center;
    gap: 16px;
    font-size: ${fontSizes.small};
    h4 {
      font-size: 24px;
      font-weight: 700;
    }
    p {
      font-size: ${fontSizes.small};
      color: ${colors.black};
      text-transform: uppercase;
      white-space: nowrap;
    }
  }
`;

export const Title = styled.h2`
  font-size: 1.5rem; /* text-2xl */
  font-weight: 700; /* font-bold */
  color: #1f2937; /* text-gray-800 */
`;

export const Badge = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem; /* gap-2 */
  padding: 0.25rem 0.75rem; /* px-3 py-1 */
  border-radius: 9999px; /* rounded-full */
  background-color: ${props => props.bgColor || '#f3f4f6'};
`;

export const BadgeText = styled.span`
  font-size: 0.875rem; /* text-sm */
  font-weight: 500; /* font-medium */
  color: ${props => props.color || '#4b5563'};
`;

/* Draft Specific */
export const DraftCard = styled.div`
  background: linear-gradient(to bottom right, #f5f3ff, #ede9fe); /* from-purple-50 to-purple-100 */
  border-left: 4px solid #9c179e;
  border-radius: 0.5rem; /* rounded-lg */
  padding: 1.5rem; /* p-6 */
`;

export const IconCircle = styled.div`
  width: 3rem; /* w-12 */
  height: 3rem; /* h-12 */
  background-color: ${props => props.bgColor || '#9c179e'};
  border-radius: 9999px; /* rounded-full */
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const CardContent = styled.div`
  flex: 1;
`;

export const CardTitle = styled.h3`
  font-size: 1.125rem; /* text-lg */
  font-weight: 700; /* font-bold */
  color: #1f2937; /* text-gray-800 */
  margin-bottom: 0.5rem; /* mb-2 */
`;

export const CardText = styled.p`
  font-size: 0.875rem; /* text-sm */
  color: #374151; /* text-gray-700 */
  margin-bottom: 1rem; /* mb-4 */
`;

export const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem; /* gap-3 */
`;

export const PrimaryButton = styled.button`
  padding: 0.625rem 1.5rem; /* px-6 py-2.5 */
  background-color: #ffeb3b;
  color: #111827; /* text-gray-900 */
  border-radius: 0.5rem; /* rounded-lg */
  font-weight: 500; /* font-medium */
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06); /* shadow-md */
  display: flex;
  align-items: center;
  gap: 0.5rem; /* gap-2 */
  border: none;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05); /* hover:shadow-lg */
  }
`;

export const SecondaryButton = styled.button`
  padding: 0.625rem 1.5rem; /* px-6 py-2.5 */
  background-color: white;
  border: 2px solid #d1d5db; /* border-2 border-gray-300 */
  color: #374151; /* text-gray-700 */
  border-radius: 0.5rem; /* rounded-lg */
  font-weight: 500; /* font-medium */
  display: flex;
  align-items: center;
  gap: 0.5rem; /* gap-2 */
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: #f9fafb; /* hover:bg-gray-50 */
  }
`;

export const DarkButton = styled.button`
  padding: 0.625rem 1.5rem; /* px-6 py-2.5 */
  background: linear-gradient(to right, #4b5563, #374151); /* from-gray-600 to-gray-700 */
  color: white;
  border-radius: 0.5rem; /* rounded-lg */
  font-weight: 500; /* font-medium */
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06); /* shadow-md */
  display: flex;
  align-items: center;
  gap: 0.5rem; /* gap-2 */
  border: none;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05); /* hover:shadow-lg */
  }
`;

/* White Cards */
export const ContentCard = styled.div`
  background-color: white;
  border-radius: 0.5rem; /* rounded-lg */
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06); /* shadow-md */
  padding: 1.5rem; /* p-6 */
`;

export const CardHeader = styled.h3`
  font-size: 1.125rem; /* text-lg */
  font-weight: 700; /* font-bold */
  color: #1f2937; /* text-gray-800 */
  margin-bottom: 1rem; /* mb-4 */
`;

/* Progress */
export const ProgressContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem; /* space-y-4 */
`;

export const ProgressInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ProgressText = styled.span`
  font-size: 0.875rem; /* text-sm */
  color: #4b5563; /* text-gray-600 */
`;

export const ProgressPercent = styled.span`
  font-size: 0.875rem; /* text-sm */
  font-weight: 700; /* font-bold */
  color: #9c179e;
`;

export const ProgressBarWrapper = styled.div`
  width: 100%;
  height: 0.75rem; /* h-3 */
  background-color: #e5e7eb; /* bg-gray-200 */
  border-radius: 9999px; /* rounded-full */
  overflow: hidden;
`;

export const ProgressBar = styled.div`
  height: 100%;
  background: linear-gradient(to right, #9c179e, #c084fc); /* from-[#9c179e] to-purple-400 */
  border-radius: 9999px; /* rounded-full */
  transition: all 0.3s;
  width: ${props => props.width || '0%'};
`;

/* Grid Details */
export const DetailsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
`;

export const DetailItem = styled.div`
  grid-column: ${props => props.fullWidth ? 'span 2 / span 2' : 'auto'};
`;

export const DetailLabel = styled.div`
  font-size: 0.75rem; /* text-xs */
  color: #6b7280; /* text-gray-500 */
  margin-bottom: 0.25rem; /* mb-1 */
`;

export const DetailValue = styled.div`
  font-size: 0.875rem; /* text-sm */
  font-weight: 600; /* font-semibold */
  color: #1f2937; /* text-gray-800 */
`;

/* Tabs */
export const TabsWrapper = styled.div`
  background-color: white;
  border-radius: 0.5rem; /* rounded-lg */
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06); /* shadow-md */
  overflow: hidden;
`;

export const TabsHeader = styled.div`
  display: flex;
  border-bottom: 1px solid #e5e7eb; /* border-b border-gray-200 */
  background-color: white;
`;

export const TabButton = styled.button`
  flex: 1;
  padding: 1rem 2rem; /* px-8 py-4 */
  font-size: 0.875rem; /* text-sm */
  font-weight: 500; /* font-medium */
  background: none;
  border: none;
  cursor: pointer;
  transition: all 0.3s;
  position: relative;
  color: ${props => props.active ? 'black' : '#6b7280'};

  &:hover {
    color: ${props => props.active ? 'black' : '#374151'};
  }
`;

export const TabIndicator = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px; /* h-0.5 */
  background-color: #41b8d5;
`;

export const TabContent = styled.div`
  padding: 1.5rem; /* p-6 */
`;

/* Pending Approval Specific */
export const ApprovalCard = styled.div`
  background: linear-gradient(to bottom right, #ecfeff, #eff6ff); /* from-cyan-50 to-blue-50 */
  border-left: 4px solid #41b8d5;
  border-radius: 0.5rem; /* rounded-lg */
  padding: 1.5rem; /* p-6 */
`;

export const RescheduleForm = styled.div`
  margin-top: 1rem; /* mt-4 */
  padding: 1rem; /* p-4 */
  background-color: white;
  border-radius: 0.5rem; /* rounded-lg */
  border: 2px solid #e5e7eb; /* border-2 border-gray-200 */
`;

export const FormTitle = styled.h4`
  font-size: 0.875rem; /* text-sm */
  font-weight: 700; /* font-bold */
  color: #1f2937; /* text-gray-800 */
  margin-bottom: 0.75rem; /* mb-3 */
`;

export const FormLabel = styled.label`
  display: block;
  font-size: 0.75rem; /* text-xs */
  color: #4b5563; /* text-gray-600 */
  margin-bottom: 0.25rem; /* mb-1 */
`;

export const SaveButton = styled.button`
  margin-top: 0.75rem; /* mt-3 */
  padding: 0.5rem 1rem; /* px-4 py-2 */
  background: linear-gradient(to right, #ffeb3b, #fdd835);
  color: #111827; /* text-gray-900 */
  border-radius: 0.5rem; /* rounded-lg */
  font-weight: 500; /* font-medium */
  font-size: 0.875rem; /* text-sm */
  border: none;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06); /* shadow-md */
  }
`;

export const FormVariables = styled.div`
  background-color: #f9fafb; /* bg-gray-50 */
  border-radius: 0.25rem; /* rounded */
  padding: 0.75rem; /* p-3 */
  display: flex;
  flex-direction: column;
  gap: 0.5rem; /* space-y-2 */
`;

export const VariableRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 0.875rem; /* text-sm */
`;

export const VariableLabel = styled.span`
  color: #4b5563; /* text-gray-600 */
  font-weight: 500;
`;

export const VariableValue = styled.span`
  color: #1f2937; /* text-gray-800 */
  font-family: monospace;
  font-size: 0.75rem; /* text-xs */
`;

/* Job Status Visualizations */
export const StatusVizContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: ${props => props.minHeight || '350px'};
  padding: 2rem 0; /* py-8 or py-12 */
`;

export const VizLayout = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.gap || '1.5rem'}; /* gap-6 or gap-8 */
  width: 100%;
`;

export const QueueCard = styled.div`
  background-color: white;
  border-radius: ${props => props.large ? '1rem' : '0.75rem'}; /* rounded-2xl or rounded-xl */
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05); /* shadow-lg */
  padding: ${props => props.large ? '2rem' : '1.5rem'}; /* p-8 or p-6 */
  width: ${props => props.large ? '16rem' : '12rem'}; /* w-64 or w-48 */
`;

export const QueueHeader = styled.div`
  background-color: black;
  color: white;
  padding: ${props => props.large ? '0.75rem 1.5rem' : '0.5rem 1rem'}; /* px-6 py-3 or px-4 py-2 */
  text-align: center;
  font-size: ${props => props.large ? '1rem' : '0.875rem'}; /* text-base or text-sm */
  font-weight: 600;
  margin: ${props => props.large ? '-2rem -2rem 1.5rem' : '-1.5rem -1.5rem 1rem'};
  border-radius: ${props => props.large ? '1rem 1rem 0 0' : '0.75rem 0.75rem 0 0'};
`;

export const QueueNumber = styled.div`
  font-size: ${props => props.large ? '3.75rem' : '3rem'}; /* text-6xl or text-5xl */
  font-weight: 700;
  text-align: center;
  color: #1f2937;
`;

export const ArrowWrapper = styled.div`
  display: flex;
  align-items: center;
  color: black;
`;

export const ProcessingCenterCard = styled.div`
  background-color: white;
  border-radius: ${props => props.large ? '1rem' : '0.75rem'};
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05); /* shadow-lg */
  width: ${props => props.large ? '20rem' : '16rem'}; /* w-80 or w-64 */
`;

export const ProcessingHeader = styled.div`
  background-color: black;
  color: white;
  padding: ${props => props.large ? '0.75rem 1.5rem' : '0.5rem 1rem'};
  text-align: center;
  font-size: ${props => props.large ? '1rem' : '0.875rem'};
  font-weight: 600;
  border-radius: ${props => props.large ? '1rem 1rem 0 0' : '0.75rem 0.75rem 0 0'};
`;

export const ProcessingBody = styled.div`
  padding: ${props => props.large ? '2rem' : '1.5rem'}; /* p-8 or p-6 */
  display: flex;
  flex-direction: column;
  gap: ${props => props.large ? '1.5rem' : '1rem'}; /* space-y-6 or space-y-4 */
`;

export const ProcessingRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const RowLabel = styled.span`
  font-size: ${props => props.large ? '1rem' : '0.875rem'};
  color: #374151;
`;

export const RowValueGroup = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.large ? '0.75rem' : '0.5rem'};
`;

export const RowNumber = styled.span`
  font-size: ${props => props.large ? '1.5rem' : '1.25rem'}; /* text-2xl or text-xl */
  font-weight: 700;
  color: #1f2937;
`;

export const RowIconBox = styled.div`
  width: ${props => props.large ? '2.5rem' : '2rem'}; /* w-10 or w-8 */
  height: ${props => props.large ? '2.5rem' : '2rem'}; /* h-10 or h-8 */
  background-color: #d4e157;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const BatchCompleteGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: ${props => props.large ? '1rem' : '0.75rem'};
  border-top: 1px solid #e5e7eb;
`;

export const BatchCompleteLabel = styled.span`
  font-size: ${props => props.large ? '0.875rem' : '0.75rem'}; /* text-sm or text-xs */
  font-weight: 700;
  color: #111827;
  line-height: normal;
`;

export const BatchCompleteCircle = styled.div`
  width: ${props => props.large ? '2.5rem' : '2rem'};
  height: ${props => props.large ? '2.5rem' : '2rem'};
  background-color: #ffeb3b;
  border-radius: 9999px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const DownloadButton = styled.button`
  width: 100%;
  background-color: #ffeb3b;
  color: #111827;
  font-weight: 700;
  padding: ${props => props.large ? '1rem' : '0.75rem'}; /* py-4 or py-3 */
  border-radius: ${props => props.large ? '1rem' : '0.75rem'}; /* rounded-2xl or rounded-xl */
  font-size: ${props => props.large ? '1rem' : '0.875rem'};
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  transition: all 0.2s;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);

  &:hover {
    background-color: #fdd835;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }
`;

export const CancelButton = styled.button`
  padding: 0.5rem 1rem; /* px-4 py-2 */
  background-color: #ef4444; /* bg-red-500 */
  color: white;
  border-radius: 0.5rem;
  font-weight: 500;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.2s;

  &:hover {
    background-color: #dc2626; /* hover:bg-red-600 */
  }
`;

export const StatusIndicator = styled.div`
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 9999px;
  background-color: ${props => {
    if (props.status === 'completed') return '#16a34a';
    if (props.status === 'running') return '#2563eb';
    if (props.status === 'scheduled') return '#9333ea';
    return '#4b5563';
  }};
`;

export const StatusBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.25rem 0.75rem;
  border-radius: 9999px;
  background-color: ${props => {
    if (props.status === 'completed') return '#f0fdf4';
    if (props.status === 'running') return '#eff6ff';
    if (props.status === 'scheduled') return '#f5f3ff';
    return '#f3f4f6';
  }};
`;

export const StatusText = styled.span`
  font-size: 0.875rem;
  font-weight: 500;
  color: ${props => {
    if (props.status === 'completed') return '#16a34a';
    if (props.status === 'running') return '#2563eb';
    if (props.status === 'scheduled') return '#9333ea';
    return '#4b5563';
  }};
`;
